import React, { useState } from 'react'
import styles from './StageAlphabet.module.css'
import Phase1 from './Phase1/Phase1'
import Phase2 from './Phase2/Phase2'

const StageAlphabet = ({
    data,
}) => {

    const [phase, setPhase] = useState(1)

    let phaseContent = null

    switch (phase) {
        case 0:
            phaseContent = <Phase1 words={data.words} />
            break
        case 1:
            phaseContent = <Phase2 words={data.words} />
            break
    }


    return (
        <div className={styles.container}>
            {phaseContent}
        </div>
    )
}

export default StageAlphabet
